module.exports = __webpack_public_path__ + "img/calander-w.31e78fe5.svg";